module.exports = __webpack_public_path__ + "img/receipt.301788a3.png";